import { normalize } from 'normalizr';
import { FormErrors, startSubmit, stopSubmit } from 'redux-form';
import { combineEpics, ofType } from 'redux-observable';
import { catchError, from, map, mergeMap } from 'rxjs';
import { IAction, IshAction } from '../actions/IshAction';
import { FULFILLED, REJECTED } from '../common/actions/ActionUtils';
import { mapError, mapPayload } from '../common/epics/EpicUtils';
import { IshActions } from '../constants/IshActions';
import { Injector } from '../injector';
import { ValidationError } from '../model';
import { ContactSchema } from '../NormalizeSchema';

const {
  contactApi
} = Injector;

export const reduxFormEpics = combineEpics(
  createStartSubmitAddContactFormEpic(IshActions.SUBMIT_ADD_CONTACT_FORM),
  createStartSubmitFormEpic(),
  createStopSubmitFormEpic()
);

function createStartSubmitAddContactFormEpic(actionType) {
  return action$ => action$.pipe(
    ofType(actionType),
    mergeMap<IAction, any>(action => from(contactApi.createOrGetContact(action.payload))
      .pipe(
        map(payload => normalize(payload, ContactSchema)),
        map(payload => ({ ...mapPayload(actionType)(payload), ...mapMeta(action) })),
        catchError(payload => mapError(actionType)(payload)),
        map(error => ({ ...error, ...mapMeta(action) }))
      )
    ));
}

function createStartSubmitFormEpic() {
  return action$ => action$.pipe(
    ofType(
      IshActions.SUBMIT_ADD_CONTACT_FORM
    ),
    map<IshAction, any>(action => startSubmit(action.meta.form))
  );
}

function createStopSubmitFormEpic() {
  return action$ => action$.pipe(
    ofType(
      REJECTED(IshActions.SUBMIT_ADD_CONTACT_FORM),
      FULFILLED(IshActions.SUBMIT_ADD_CONTACT_FORM)
    ),
    map<IshAction, any>(action => {
      if (isValidationError(action)) {
        return stopSubmit(action.meta.form, convertToReduxFormErrors(action.payload.data));
      } else {
        return stopSubmit(action.meta.form);
      }
    })
  );
}

function convertToReduxFormErrors<T>(backendError: ValidationError): FormErrors<T> {
  const errors: FormErrors = {};

  backendError.fieldsErrors.forEach(field => {
    errors[field.name] = field.error;
  });

  errors._error = backendError.formErrors.join(' ');

  return errors;
}

function isValidationError(action: IshAction<any>): boolean {
  return !!(action.error && action.payload.data.formErrors);
}

function mapMeta({ meta: { form } }: IAction) {
  return { meta: { form } };
}
